var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pack-info',{attrs:{"packId":_vm.packId,"showMenu":true}}),_c('v-container',{attrs:{"fluid":""}},[_c('search')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }